<ng-container *ngTemplateOutlet="toggleButton"></ng-container>
<ng-container *ngIf="mode === VIEW_MODE.ADD || mode === VIEW_MODE.EDIT">
  <app-pqq-read-only-form></app-pqq-read-only-form>
</ng-container>
<ng-container *ngIf="mode === VIEW_MODE.VIEW">
  <app-pre-qualification-questionnaire-view></app-pre-qualification-questionnaire-view>
</ng-container>

<ng-template #toggleButton>
  <div class="sticky-switch-container">
    <div
      class="mode-toggle"
      [class.edit-mode]="isEditMode"
      (click)="toggleMode()"
    >
      <div class="toggle-option view-option" [class.active]="!isEditMode">
        <span>View</span>
      </div>
      <div
        (click)="clickEditProjectBrief()"
        class="toggle-option edit-option"
        [class.active]="isEditMode"
      >
        <span>Edit</span>
      </div>
    </div>
  </div>
</ng-template>
